import React from 'react'
import { useSelector } from 'react-redux'
import { makeStyles } from '@material-ui/core/styles'
import { Typography } from '@material-ui/core'
import { Button } from '../root/components/common'
import { NavLink } from 'react-router-dom'

const useStyles = makeStyles(() => ({
    container: {
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
        textAlign: 'center',
        alignItems: 'center'
    },
    btnText: {
        textDecoration: 'none',
        color: '#fff'
    },
    title: {
        fontSize: 19,
        fontWeight: 600,
        lineHeight: '30px'
    },
    text: {
        fontSize: 16,
        fontWeight: 300,
        lineHeight: '24px'
    }
}))

export default function HotSwapSuccess({ swapType }) {
    const { locale } = useSelector(state => state.main)
    const classes = useStyles()
    return (
        <div className={classes.container}>
            <Typography className={classes.title}>
                {locale.hotSwap[swapType].successTitle}
            </Typography>
            <Typography className={classes.text}>
                {locale.hotSwap[swapType].successDesc}
            </Typography>
            <Button style={{ marginTop: 62 }}>
                <NavLink className={classes.btnText} to={`/hot-swap`}>
                    {locale.hotSwap.backToDashboard}
                </NavLink>
            </Button>
        </div>
    )
}
